var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoCloseCircleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.08333C9.48675 1.08333 11.9167 3.51325 11.9167 6.5C11.9167 9.48675 9.48675 11.9167 6.5 11.9167C3.51325 11.9167 1.08333 9.48675 1.08333 6.5C1.08333 3.51325 3.51325 1.08333 6.5 1.08333ZM6.5 0C2.91038 0 0 2.91038 0 6.5C0 10.0896 2.91038 13 6.5 13C10.0896 13 13 10.0896 13 6.5C13 2.91038 10.0896 0 6.5 0ZM9.75 8.95808L7.26267 6.49458L9.72508 4.00996L8.95808 3.25L6.49621 5.73571L4.01104 3.27492L3.25 4.03596L5.73788 6.50163L3.27492 8.98896L4.03596 9.75L6.50325 7.2605L8.99004 9.72508L9.75 8.95808Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseCircleWhite);
export default __webpack_public_path__ + "static/media/ico-close-circle-white.bae55a5f121159c566f6dc28ea7ae340.svg";
export { ForwardRef as ReactComponent };